export default "__VITE_ASSET__BO6d8AzD__"